import { render, staticRenderFns } from "./SiteParser.vue?vue&type=template&id=20e1f306&scoped=true&"
import script from "./SiteParser.vue?vue&type=script&lang=js&"
export * from "./SiteParser.vue?vue&type=script&lang=js&"
import style0 from "./SiteParser.vue?vue&type=style&index=0&id=20e1f306&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e1f306",
  null
  
)

export default component.exports